<template>
  <main>
    <div class="page-area">
      <div class="breadcumb-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="breadcrumb text-center">
              <div class="section-headline white-headline">
                <h3>关于海星云</h3>
              </div>
              <!-- <ul class="breadcrumb-bg">
                <li class="home-bread">支持</li>
                <li>关于海星云</li>
              </ul>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End breadcumb Area -->
    <!-- Start About Area -->
    <div class="About-feature-area bg-color-1 page-padding">
      <div class="container">
        <div class="row">
          <div class="about-feature">
            <!-- Start column -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-about">
                <div class="feature-icon">
                  <i class="icon icon-cloud"></i>
                </div>
                <div class="feature-text">
                  <h4>云计算</h4>
                  <p>
                    游戏渲染与计算放在云端，本地无需再堆叠配置，耗电量也相应大幅减少，游玩时长与游戏质量都得到了次世代级的提升。
                  </p>
                </div>
              </div>
            </div>
            <!-- Start column -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-about">
                <div class="feature-icon">
                  <i class="icon icon-layers"></i>
                </div>
                <div class="feature-text">
                  <h4>跨平台</h4>
                  <p>
                    一款游戏多平台畅玩。“小破本”？
                    MAC本？安卓手机？海星云平台通通帮您搞定！
                  </p>
                </div>
              </div>
            </div>
            <!-- Start column -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="single-about">
                <div class="feature-icon">
                  <i class="icon icon-clock"></i>
                </div>
                <div class="feature-text">
                  <h4>无需等待</h4>
                  <p>
                    云游戏时代，游戏的下载与更新配置在服务器端完成，你无需再等待，点开即享。&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                </div>
              </div>
            </div>
            <!-- End column -->
          </div>
        </div>
      </div>
    </div>
    <div class="about-area bg-color-2 area-padding u-coment">
      <ul class="container">
        <li>
          <h1>欢迎来到海星云-硬核极客玩家聚集地</h1>
          <p class="fl" style="text-indent: 40px">
            <br />
          </p>
          <p style="text-indent: 40px">
            海星云平台是星瀛科技自主研发的高性能云电脑。
            团队通过组建大规模GPU集群网络，融合高效率视频编解码串流与5G网络优化技术，自主研发高性能云电脑——“海星云”(haixingcloud.com
            )，为传统PC、移动手机、客厅电视、VR等多客户端用户提供了软硬件综合解决方案，降低了用户使用高端硬件设备的门槛，让更多的用户实现了任意时间、任意地点、任意设备的高画质流畅体验，不再是“只能看UP视频”的云玩家，不再需要“5帧不卡，10帧流畅”的自我安慰。
          </p>
          <p style="text-indent: 40px">
            海星云电脑是指本地客户端通过网络远程连接到云主机，获取计算能力的一种方式。云主机使用的是当前高配置硬件
            ，通过客户端传输到本地进行画面展示。现实中的网咖是由显示器和主机构成的，而海星云则是由用户手中的设备充当显示器，云端机房经过互联网的加持后充当主机构成的。而这个充当显示器的设备，可以是电脑显示器、电视机，也可以是平板电脑或手机。在线下网咖能做的事情，海星云都能做到，即便是用户手中配置低的本地设备也可以进行高配置要求的GPU计算：进行设计建模、动画渲染、直播等，均可有超强的体验。
          </p>
        </li>
      </ul>
    </div>
    <!-- 全局qq和微信联系方式 index中有全局 -->
    <div class="hotline">
      <i class="fa fa-qq link"></i>
      <div class="qrcode-div">
        <img
          draggable="false"
          class="image"
          style="width: 100%; height: 100%"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/qqCode.png`"
        />
      </div>
    </div>
    <div class="hotline2">
      <i class="fa fa-wechat link-wechat"></i>
      <div class="qrcode-div2">
        <img
          class="image"
          draggable="false"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/Wechat2.jpg`"
        />
      </div>
    </div>
    <!-- End About Area -->
    <!-- about-area start -->

    <!-- about-area end -->
    <!-- Team area start -->
    <!-- <div class="team-area bg-color-1 area-padding-2">
      <div class="container">

        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="section-headline white-headline text-center">
              <h3>Our Experts</h3>
              <p>Cavalier Studios has been creating innovative games since 2003. We offer our clients professional development services.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="team-member text-center">

            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="single-member">
                <div class="team-img">
                  <a >
                    <img src="../assets/new/img/team/t1.jpg" alt />
                  </a>
                </div>
                <div class="team-content">
                  <h4>
                    <a >Hamilton</a>
                  </h4>
                  <p>Games Developer</p>
                  <ul class="team-hover">
                    <li>
                      <a >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="single-member">
                <div class="team-img">
                  <a >
                    <img src="../assets/new/img/team/t2.jpg" alt />
                  </a>
                </div>
                <div class="team-content">
                  <h4>
                    <a >Mickhel</a>
                  </h4>
                  <p>Games Designer</p>
                  <ul class="team-hover">
                    <li>
                      <a >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="single-member">
                <div class="team-img">
                  <a >
                    <img src="../assets/new/img/team/t3.jpg" alt />
                  </a>
                </div>
                <div class="team-content">
                  <h4>
                    <a >Arnold</a>
                  </h4>
                  <p>Games developer</p>
                  <ul class="team-hover">
                    <li>
                      <a >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="single-member">
                <div class="team-img">
                  <a >
                    <img src="../assets/new/img/team/t4.jpg" alt />
                  </a>
                </div>
                <div class="team-content">
                  <h4>
                    <a >Gonjamul</a>
                  </h4>
                  <p>Social marketer</p>
                  <ul class="team-hover">
                    <li>
                      <a >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a >
                        <i class="fa fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>-->
    <!-- team area end -->
    <!-- Start Brand Area -->
    <!-- <div class="brand-area bg-color-2 area-padding">
      <div class="container">
        <div class="row">
          <div class="brand-items">
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/1.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/2.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/3.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/4.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/5.png" alt />
                </a>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-xs-12">
              <div class="single-brand-item">
                <a >
                  <img src="../assets/new/img/brand/6.png" alt />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!-- end Brand Area -->
    <!-- Start Challange Area -->
    <!-- <div class="challange-area bg-color-1 area-padding">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="section-headline white-headline text-center">
              <h3>Competition</h3>
              <p>Cavalier Studios has been creating innovative games since 2003. We offer our clients professional development services.</p>
            </div>
          </div>
        </div>
        <div class="row">

          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="tab-menu">

              <ul class="nav nav-tabs" role="tablist">
                <li class="active">
                  <a href="#p-view-1" role="tab" data-toggle="tab">
                    <img class="cha-img" src="../assets/new/img/challange/c1.jpg" alt="challange image" />
                    <span class="title-date">
                      <span class="cha-title">Challanger fight competition</span>
                      <span class="cha-date">September 05, 2018</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#p-view-2" role="tab" data-toggle="tab">
                    <img class="cha-img" src="../assets/new/img/challange/c2.jpg" alt="challange image" />
                    <span class="title-date">
                      <span class="cha-title">Temple Fight Challanger</span>
                      <span class="cha-date">December 01, 2018</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#p-view-3" role="tab" data-toggle="tab">
                    <img class="cha-img" src="../assets/new/img/challange/c3.jpg" alt="challange image" />
                    <span class="title-date">
                      <span class="cha-title">Angels fight competition</span>
                      <span class="cha-date">November 12, 2018</span>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#p-view-4" role="tab" data-toggle="tab">
                    <img class="cha-img" src="../assets/new/img/challange/b4.jpg" alt="challange image" />
                    <span class="title-date">
                      <span class="cha-title">Dangers War fight man</span>
                      <span class="cha-date">September 20, 2018</span>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="tab-content">
              <div class="tab-pane active" id="p-view-1">
                <div class="tab-inner">
                  <div class="single-page">
                    <div class="page-img">
                      <img src="../assets/new/img/challange/b1.jpg" alt />
                    </div>
                    <a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="p-view-2">
                <div class="tab-inner">
                  <div class="single-page">
                    <div class="page-img">
                      <img src="../assets/new/img/challange/b2.jpg" alt />
                    </div>
                    <a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="p-view-3">
                <div class="tab-inner">
                  <div class="single-page">
                    <div class="page-img">
                      <img src="../assets/new/img/challange/b3.jpg" alt />
                    </div>
                    <a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="p-view-4">
                <div class="tab-inner">
                  <div class="single-page">
                    <div class="page-img">
                      <img src="../assets/new/img/challange/b4.jpg" alt />
                    </div>
                    <a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>-->
  </main>
</template>
<script>
export default {
  metaInfo: {
    title:
      '海星云-关于海星云',
    meta: [
      {
        name: 'keywords',
        content:
          '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:
          '海星云游戏平台致力于为用户提供高效、便捷的游戏体验，平台包含了400多款大型正版热门游戏，无需下载更新即可畅玩游戏。多平台畅玩，“小破本”？ MAC本？安卓手机？海星云平台通通帮您搞定！'
      }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/aboutus_details.vue